import { makeAutoObservable } from 'mobx';
import {DomainStore} from 'shared/store';
import {redirect} from 'shared/tools';
import {User} from 'main/stores/users';
import {endpoints, types} from 'main/tools';

class PasswordResetState {
  store = new DomainStore();

  user = new User();
  errors = {};

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  async submit() {
    const {model, errors} = await this.store.patch(
      endpoints.PASSWORD_RESETS.with(this.token),
      types.USER,
      this.user
    );

    if (model) {
      if (model.partner) {
        await redirect('/partner/login?password_reset_successful=true');
      } else {
        await redirect('/user_session/new?password_reset_successful=true');
      }
    }

    this.errors = errors;
  }

  get token() {
    const pathParts = window.location.pathname.split('/');
    return pathParts[2];
  }
}

export default PasswordResetState;
